import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const PaymentProofModal = ({ title, onClose, modalData, submitData }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    setValue,
    trigger,
  } = useForm({
    defaultValues: {
      studentFirstRegistrationId: modalData.id,
      studentId: modalData.studentId,
      receiptName: "",
      base64Url: "",
      createdBy: localStorage.getItem("userId"),
    },
  });

  const [isLoading, setIsLoading] = useState(false);

  const [imageName, setImageName] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);

  // if (!modalData) {
  //   return null;
  // }

  // // Check for existing receipt data
  const existingReceipt = modalData?.receiptName;
  const existingImagePath = modalData?.invoiceProofPath;

  useEffect(() => {
    if (existingImagePath) {
      const imageUrl = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${existingImagePath}`;
      setPreviewUrl(imageUrl);
      setImageName(existingImagePath);
    }
  }, [existingImagePath, setValue]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setImageName(file.name);

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Url = reader.result.split(",")[1];
        setValue("base64Url", base64Url, { shouldValidate: true });
        setPreviewUrl(reader.result);
        trigger("receiptName");
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl(null);
    }
  };

  const saveData = async (formData) => {
    setIsLoading(true);
    try {
      const formWithAdditionalData = {
        ...formData,
        receiptName: imageName,
        activityName: modalData.group,
      };

      await submitData(formWithAdditionalData);
    } catch (error) {
      console.error("Error processing payment:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(saveData)}>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label">
                      Image Preview
                      <span className="text-danger fs-9">*</span>
                    </label>
                    <div className="image-uploader-wrapper-2 d-flex flex-column align-items-center">
                      <div className="image-preview d-flex justify-content-center align-items-center flex-shrink-0 mb-2 mt-1">
                        {previewUrl ? (
                          <img src={previewUrl} alt="Preview" />
                        ) : (
                          <div>
                            <span className="fas fa-image fs-3 text-light"></span>
                          </div>
                        )}
                      </div>
                      <input
                        {...register("receiptName", {
                          required: !previewUrl
                            ? "This field is required."
                            : false,
                        })}
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFileChange}
                        // disabled={!!existingReceipt}
                      />
                    </div>
                    {errors.receiptName && (
                      <small className="text-danger">
                        {errors.receiptName.message}
                      </small>
                    )}
                  </div>
                  <div className="col-12">
                    <div className="d-flex gap-2 justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary"
                        //disabled={isLoading || !!existingReceipt}
                      >
                        {isLoading ? "Save" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default PaymentProofModal;
